module.exports = __webpack_public_path__ + "img/logo.b57a4f54.svg";